import React from "react";

import { Form, Input, Modal, message, Radio, Select } from "antd";
import {
  fetchUpdateSoftware,
  fetchUpdateHardware,
} from "../../../../api/equipment";
const formItemLayout = {
  labelCol: {
    xs: { span: 8 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 40 },
    sm: { span: 20 },
  },
};
const { Option } = Select;
class VersionUpdate extends React.Component {
  state = {
    showUpdateField: false,
  };
  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        const {
          capsuleIdList,
          versionUpdateCancel,
          clearSelected,
          selectedRowKeys,
        } = this.props;
        if (values.type == 0) {
          fetchUpdateSoftware({ capsuleIdList: capsuleIdList }).then((res) => {
            if (res.success) {
              if (selectedRowKeys.length > 0) {
                clearSelected();
              }
              message.success("操作成功");
              this.setState({
                showUpdateField: false,
              });
              versionUpdateCancel();
            }
          });
        } else {
          fetchUpdateHardware({
            capsuleIdList: capsuleIdList,
            position: values.position,
          }).then((res) => {
            if (res.success) {
              if (selectedRowKeys.length > 0) {
                clearSelected();
              }
              this.setState({
                showUpdateField: false,
              });
              message.success("操作成功");
              versionUpdateCancel();
            }
          });
        }
      }
    });
  };
  typeChange = (e) => {
    console.log(e.target.value);
    if (e.target.value == 1) {
      this.setState({
        showUpdateField: true,
      });
    } else {
      this.setState({
        showUpdateField: false,
      });
    }
  };
  renderPositionOptions = () => {
    return this.props.hardwarePositionList.map((item) => (
      <Option key={item.position} value={item.position}>
        {item.name}
      </Option>
    ));
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { versionUpdateVisible, versionUpdateCancel } = this.props;
    const { showUpdateField } = this.state;
    return (
      <Modal
        width={700}
        destroyOnClose={true}
        title="版本更新"
        visible={versionUpdateVisible}
        onOk={this.handleOk}
        onCancel={() => {
          this.setState({
            showUpdateField: false,
          });
          versionUpdateCancel();
        }}
      >
        <Form onSubmit={this.handleOk} {...formItemLayout}>
          <Form.Item label="更新类型:">
            {getFieldDecorator("type", {
              initialValue: 0,
              rules: [{ required: true, message: "请选择更新类型" }],
            })(
              <Radio.Group onChange={this.typeChange}>
                <Radio value={0}>软件更新</Radio>
                <Radio value={1}>硬件更新</Radio>
              </Radio.Group>
            )}
          </Form.Item>
          {showUpdateField ? (
            <Form.Item label="更新位置:">
              {getFieldDecorator("position", {
                rules: [{ required: true, message: "请选择更新位置" }],
              })(
                <Select placeholder="请选择更新位置" style={{ width: 250 }}>
                  {this.renderPositionOptions()}
                </Select>
              )}
            </Form.Item>
          ) : null}
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(VersionUpdate);
